import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { statsLeadersNavSelector } from 'store/modules/statspro/stats-leaders/selectors/nav-selector';
import { STATS_CATEGORY_ARRAY } from '../../../common/config/categories';
import PropTypes from 'prop-types';
import { statsLeadersActions } from 'common/store/modules/statspro/stats-leaders';

export const CategoryNavItem = ({ hideLabel = false }) => {
    const dispatch = useDispatch();
    const nav = useSelector(statsLeadersNavSelector);

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                className="w-100"
                items={STATS_CATEGORY_ARRAY}
                itemToString={(item) => item}
                initialSelectedItem={nav.category}
                activeItem={nav.category}
                type="with-default"
                icon="chart"
                label={getTranslation('label.statsLeaders.nav.category')}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        statsLeadersActions.setNavItem({
                            navItem: 'category',
                            value: selectedItem
                        })
                    );
                }}
                hideLabel={hideLabel}
            />
        </div>
    );
};

CategoryNavItem.propTypes = {
    hideLabel: PropTypes.bool
};
